
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcProgressButton as ObcProgressButtonElement} from '@oicl/openbridge-webcomponents/dist/components/progress-button/progress-button.js';
 
 
 

 
 export const ObcProgressButton = createComponent({
   react: React,
   tagName: 'obc-progress-button',
   elementClass: ObcProgressButtonElement,
   events: {
     
   }
  });
 
 